import { ActivityComponentType } from '@stackflow/react'
import { useState } from 'react'
import { n_material_list } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { SelectMaterialProvider } from '../../../pages/[lang]/portal/lessons/materials/[lessonId]'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import { SearchResultListSection } from '../../new-portal/lessons/materials/SelectMaterialBody'
import SelectMaterialSearchSection from '../../new-portal/lessons/materials/SelectMaterialSearchSection'
import WebviewStackContainer from '../common/WebviewStackContainer'

const LessonMaterialSearchListActivity: ActivityComponentType = () => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { t } = useTranslation()

  const [webviewKeyword, setWebviewKeyword] = useState('')

  return (
    <SelectMaterialProvider>
      <WebviewStackContainer onBack={pop} title={t(n_material_list.all.title_search)}>
        <div className="relative mt-[16px] h-full">
          <SelectMaterialSearchSection setWebviewKeyword={setWebviewKeyword} className="min-w-full px-[16px]" />
          {webviewKeyword.length >= 1 ? (
            <div className="mt-[20px] px-[16px]">
              <SearchResultListSection keywords={webviewKeyword} />
            </div>
          ) : (
            <div className="h-full"></div>
          )}
        </div>
      </WebviewStackContainer>
    </SelectMaterialProvider>
  )
}

export default LessonMaterialSearchListActivity
